<script lang="ts" setup>
const lists = ref([
  {
    title: '豐富多元的環境',
    text: '享受工作與生活的平衡'
  },
  {
    title: '獎酬津貼',
    text: '完善的薪酬制度：年終獎金、績效獎金、節慶禮金及各項補助等'
  },
  {
    title: '福利制度',
    text: '彈性一小時上下班時間，基本勞健退保障再加團體保險'
  },
  {
    title: '健康娛樂',
    text: ' 專人紓壓按摩，年度尾牙派對、運動會及創意十足的恆有勁活動'
  },
  {
    title: '工作環境',
    text: '寬敞舒適的辦公座位，無限供應氣泡水及Coway淨水'
  }
])
</script>

<template>
  <section class="benefit">
    <div class="benefit__top">
      <Intro subtitle="benefit" :data="{
        title: '公司福利'
      }" class="align-left display80" />
    </div>
    <div class="benefit__lists">
      <div class="benefit__lists__item" v-for="(item, index) in lists" :key="index">
        <div class="benefit__lists__no">
          {{ index < 10 ? '0' + (index + 1) : index + 1 }} </div>
            <div class="benefit__lists__title">
              {{ item.title }}
            </div>
            <div class="benefit__lists__text">
              {{ item.text }}
            </div>
        </div>
      </div>
  </section>
</template>

<style lang="scss" scoped>
.benefit {
  padding-top: toRem(210);
  padding-bottom: toRem(240);
  @include grid;

  @include max-media(990) {
    @include grid(4, 24);
  }

  @include max-media(640) {
    padding-top: toRem(80);
    padding-bottom: toRem(80);
  }

  &__top {
    grid-column: 1 / span 12;
    margin-bottom: toRem(24);

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__lists {
    grid-column: 5 / span 8;

    @include max-media(990) {
      grid-column: 1 / span 4;
    }

    &__item {
      border-top: 1px solid $color-gray-line;
      padding-top: toRem(24);
      padding-bottom: toRem(24);

      @include min-media(641) {
        @include grid(8, 24);
      }

      @include max-media(640) {
        display: flex;
        flex-wrap: wrap;
      }

      &:not(:last-child) {
        margin-bottom: toRem(32);
      }
    }

    &__no {
      grid-column: 1 / span 1;
      font-size: toRem(32);
      font-weight: 500;
      line-height: 0.8;
      color: $color-gray-3;
      font-family: $font-TextaAlt;

      @include max-media(640) {
        width: toRem(45);
        font-size: toRem(24);
        padding-right: toRem(12);
        padding-top: toRem(3);
      }
    }

    &__title {
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;
      color: $color-brand-3;

      @include min-media(641) {
        grid-column: 2 / span 3;
      }

      @include max-media(640) {
        font-size: toRem(20);
        line-height: 1.4;
        margin-bottom: toRem(12);
      }
    }

    &__text {
      font-size: toRem(16);
      font-weight: 400;
      line-height: 1.45;

      @include min-media(641) {
        grid-column: 5 / span 3;
      }

      @include max-media(640) {
        width: 100%;
        padding-left: toRem(45);
      }
    }
  }
}</style>
